import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/consumer/Link';
import Placeholder from 'components/consumer/Placeholder';
const FlatButton = React.forwardRef((t0, ref) => {
  const $ = _c(26);
  const {
    children,
    color,
    isSelected: t1,
    isSelectedButtonFilled: t2,
    loading: t3,
    onClick,
    onMouseEnter,
    onMouseLeave,
    scrollOnMobile: t4,
    spacer: t5,
    to
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const isSelectedButtonFilled = t2 === undefined ? false : t2;
  const loading = t3 === undefined ? false : t3;
  const scrollOnMobile = t4 === undefined ? false : t4;
  const spacer = t5 === undefined ? false : t5;
  if (spacer) {
    let t6;
    if ($[0] !== scrollOnMobile) {
      t6 = classNames("text-xs font-bold bg-transparent border border-solid border-gray-light6 rounded text-gray inline-block p-1.5 no-underline transition-[all_75ms_ease] hover:border hover:border-solid hover:border-gray-light2 hover:text-gray hover:cursor-pointer hover:max-[767px]:cursor-auto", {
        "max-[767px]:border-0 max-[767px]:m-0 max-[767px]:px-[7px] max-[767px]:py-0 max-[767px]:min-h-[35px] max-[767px]:invisible md:hidden": scrollOnMobile
      });
      $[0] = scrollOnMobile;
      $[1] = t6;
    } else {
      t6 = $[1];
    }
    let t7;
    if ($[2] !== t6) {
      t7 = <div className={t6} />;
      $[2] = t6;
      $[3] = t7;
    } else {
      t7 = $[3];
    }
    return t7;
  }
  if (loading) {
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Placeholder type="rect" loading={true} className="text-xs font-bold bg-transparent rounded text-gray inline-block p-1.5 no-underline transition-[all_75ms_ease] hover:text-gray min-h-[35px] max-w-[65px] border border-solid border-gray-light8 hover:border hover:border-solid hover:border-gray-light8 hover:cursor-default" />;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    return t6;
  }
  const t6 = isSelected && isSelectedButtonFilled;
  const t7 = isSelected && !isSelectedButtonFilled;
  const t8 = color === "red";
  let t9;
  if ($[5] !== isSelected || $[6] !== scrollOnMobile || $[7] !== t6 || $[8] !== t7 || $[9] !== t8) {
    t9 = classNames("text-xs font-bold bg-transparent border border-solid border-gray-light6 rounded text-gray inline-block p-1.5 no-underline [transition:all_75ms_ease]", "hover:border hover:border-solid hover:border-gray-light2 hover:text-gray hover:cursor-pointer", {
      "!text-gray !border-brand-dark !hover:border !hover:border-solid !hover:border-brand-darker !hover:text-gray-dark": isSelected,
      "!bg-[#107C8C] !text-white": t6,
      "!bg-white": t7,
      "max-[767px]:whitespace-nowrap": scrollOnMobile,
      "!text-red hover:!text-red hover:!border-[#832829] !bg-[#F7F1F2]": t8
    });
    $[5] = isSelected;
    $[6] = scrollOnMobile;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const classes = t9;
  if (to) {
    let t10;
    if ($[11] !== children || $[12] !== classes || $[13] !== onClick || $[14] !== onMouseEnter || $[15] !== onMouseLeave || $[16] !== ref || $[17] !== to) {
      t10 = <Link className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} to={to} ref={ref}>{children}</Link>;
      $[11] = children;
      $[12] = classes;
      $[13] = onClick;
      $[14] = onMouseEnter;
      $[15] = onMouseLeave;
      $[16] = ref;
      $[17] = to;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    return t10;
  }
  let t10;
  if ($[19] !== children || $[20] !== classes || $[21] !== onClick || $[22] !== onMouseEnter || $[23] !== onMouseLeave || $[24] !== ref) {
    t10 = <button className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} type="button" ref={ref}>{children}</button>;
    $[19] = children;
    $[20] = classes;
    $[21] = onClick;
    $[22] = onMouseEnter;
    $[23] = onMouseLeave;
    $[24] = ref;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
});
FlatButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['red']),
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  scrollOnMobile: PropTypes.bool,
  spacer: PropTypes.bool,
  isSelectedButtonFilled: PropTypes.bool,
  to: PropTypes.string
};
export default FlatButton;